/**
 * Draggable split divider — resizes editor and preview panels.
 */

export function initSplitter(): void {
  const divider = document.getElementById('split-divider');
  const editorPanel = document.querySelector('.editor-panel') as HTMLElement;
  const previewPanel = document.querySelector('.preview-panel') as HTMLElement;

  if (!divider || !editorPanel || !previewPanel) return;

  // Set initial editor width: measure toolbar content or fallback to 50%
  const toolbar = editorPanel.querySelector('.editor-toolbar') as HTMLElement;
  if (toolbar) {
    const toolbarRight = toolbar.scrollWidth + 32; // 16px padding each side
    const workspace = editorPanel.parentElement as HTMLElement;
    const workspaceWidth = workspace.clientWidth;
    const minPanel = 750;
    const previewMin = Math.floor(workspaceWidth / 2);
    const maxEditor = workspaceWidth - previewMin - 2; // 2px divider
    const initialWidth = Math.min(Math.max(toolbarRight, minPanel), maxEditor);
    editorPanel.style.width = initialWidth + 'px';
    editorPanel.style.flexShrink = '0';
  } else {
    editorPanel.style.width = '50%';
    editorPanel.style.flexShrink = '0';
  }

  let isDragging = false;

  divider.addEventListener('mousedown', (e) => {
    e.preventDefault();
    isDragging = true;
    divider.classList.add('dragging');
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;

    const workspace = editorPanel.parentElement as HTMLElement;
    const workspaceRect = workspace.getBoundingClientRect();
    const editorMin = 750;
    const dividerWidth = 2;
    const previewMin = Math.floor(workspaceRect.width / 2);

    let newEditorWidth = e.clientX - workspaceRect.left;
    newEditorWidth = Math.max(editorMin, newEditorWidth);
    newEditorWidth = Math.min(workspaceRect.width - previewMin - dividerWidth, newEditorWidth);

    editorPanel.style.width = newEditorWidth + 'px';
  });

  window.addEventListener('mouseup', () => {
    if (isDragging) {
      isDragging = false;
      divider.classList.remove('dragging');
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    }
  });
}
